'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _creditcard = require('./creditcard');

var _creditcard2 = _interopRequireDefault(_creditcard);

var _neteller = require('./neteller');

var _neteller2 = _interopRequireDefault(_neteller);

var _venuspoint = require('./venuspoint');

var _venuspoint2 = _interopRequireDefault(_venuspoint);

var _vega = require('./vega');

var _vega2 = _interopRequireDefault(_vega);

var _skrill = require('./skrill');

var _skrill2 = _interopRequireDefault(_skrill);

var _banklocal = require('./banklocal');

var _banklocal2 = _interopRequireDefault(_banklocal);

var _paypal = require('./paypal');

var _paypal2 = _interopRequireDefault(_paypal);

var _trustly = require('./trustly');

var _trustly2 = _interopRequireDefault(_trustly);

var _muchbetter = require('./muchbetter');

var _muchbetter2 = _interopRequireDefault(_muchbetter);

var _bankdomestic = require('./bankdomestic');

var _bankdomestic2 = _interopRequireDefault(_bankdomestic);

var _bankdomesticiban = require('./bankdomesticiban');

var _bankdomesticiban2 = _interopRequireDefault(_bankdomesticiban);

var _bankinternationaliban = require('./bankinternationaliban');

var _bankinternationaliban2 = _interopRequireDefault(_bankinternationaliban);

var _bankrepeat = require('./bankrepeat');

var _bankrepeat2 = _interopRequireDefault(_bankrepeat);

var _instadebit = require('./instadebit');

var _instadebit2 = _interopRequireDefault(_instadebit);

var _idebit = require('./idebit');

var _idebit2 = _interopRequireDefault(_idebit);

var _ecopayz = require('./ecopayz');

var _ecopayz2 = _interopRequireDefault(_ecopayz);

var _zimpler = require('./zimpler');

var _zimpler2 = _interopRequireDefault(_zimpler);

var _interac = require('./interac');

var _interac2 = _interopRequireDefault(_interac);

var _bankiban = require('./bankiban');

var _bankiban2 = _interopRequireDefault(_bankiban);

var _astropaycard = require('./astropaycard');

var _astropaycard2 = _interopRequireDefault(_astropaycard);

var _astropaybank = require('./astropaybank');

var _astropaybank2 = _interopRequireDefault(_astropaybank);

var _bank = require('./bank');

var _bank2 = _interopRequireDefault(_bank);

var _bankintl = require('./bankintl');

var _bankintl2 = _interopRequireDefault(_bankintl);

var _jeton = require('./jeton');

var _jeton2 = _interopRequireDefault(_jeton);

var _cryptocurrency = require('./cryptocurrency');

var _cryptocurrency2 = _interopRequireDefault(_cryptocurrency);

var _bestpay = require('./bestpay');

var _bestpay2 = _interopRequireDefault(_bestpay);

var _ezeewallet = require('./ezeewallet');

var _ezeewallet2 = _interopRequireDefault(_ezeewallet);

var _mifinity = require('./mifinity');

var _mifinity2 = _interopRequireDefault(_mifinity);

var _paramount = require('./paramount');

var _paramount2 = _interopRequireDefault(_paramount);

var _cashlib = require('./cashlib');

var _cashlib2 = _interopRequireDefault(_cashlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  creditcard: _creditcard2.default,
  neteller: _neteller2.default,
  skrill: _skrill2.default,
  venuspoint: _venuspoint2.default,
  vega: _vega2.default,
  banklocal: _banklocal2.default,
  paypal: _paypal2.default,
  trustly: _trustly2.default,
  muchbetter: _muchbetter2.default,
  bankdomestic: _bankdomestic2.default,
  bankdomesticIBAN: _bankdomesticiban2.default,
  bankinternationalIBAN: _bankinternationaliban2.default,
  bankrepeat: _bankrepeat2.default,
  instadebit: _instadebit2.default,
  idebit: _idebit2.default,
  ecopayz: _ecopayz2.default,
  zimpler: _zimpler2.default,
  interac: _interac2.default,
  bankiban: _bankiban2.default,
  astropaycard: _astropaycard2.default,
  astropaybank: _astropaybank2.default,
  bank: _bank2.default,
  bankintl: _bankintl2.default,
  jeton: _jeton2.default,
  cryptocurrency: _cryptocurrency2.default,
  bestpay: _bestpay2.default,
  ezeewallet: _ezeewallet2.default,
  mifinity: _mifinity2.default,
  paramount: _paramount2.default,
  cashlib: _cashlib2.default
};